import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiHomeComponent } from '@fi-app/home/home.component';
import { WidgetService } from '@fi-app/widget/widget.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { WidgetAdministrateService } from '@fi-app/widget/widget-administrate.service';
import { ModuleType } from '@fi-shared/types/module-type';
import { Component, ViewEncapsulation } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { WidgetModel } from '@fi-app/widget/model/widget.model';

export const FiHomeState: Ng2StateDeclaration = {
    name: FiStateNames.Home._name,
    url: '/',
    params: { isOnlyUnvisited: null },
    component: FiHomeComponent,
    resolve: {
        widgets: [WidgetService, FiHomeStateResolveWidgets],
        widgetAdministrate: ['widgets', WidgetAdministrateService, FiHomeStateResolveWidgetAdministrate],
        widgetAdministrateWidgets: [
            'widgets',
            'widgetAdministrate',
            WidgetAdministrateService,
            FiHomeStateResolveWidgetAdministrateWidgets,
        ],
    },
};

export function FiHomeStateResolveWidgets(widgetService: WidgetService) {
    return widgetService.getWidgets(ObjectTypes.FirstPage);
}

export function FiHomeStateResolveWidgetAdministrate(
    widgets: WidgetModel[],
    widgetAdministrateService: WidgetAdministrateService,
) {
    const promise = widgetAdministrateService.getWidgetAdministrateForModule(ModuleType.FirstPage);
    promise.then((widgetAdministrate) => {
        if (!widgetAdministrate.BaseUrl) {
            widgetAdministrateService.InitAdministrateWidgetDefaultLayout(widgetAdministrate, widgets);
        }
    });
    return promise;
}

export function FiHomeStateResolveWidgetAdministrateWidgets(Widgets, WidgetAdministrate, WidgetAdministrateService) {
    return WidgetAdministrateService.BuildWidgetAdministrateWidgetsList(WidgetAdministrate, Widgets);
}

export const FiHomePostState: Ng2StateDeclaration = {
    name: FiStateNames.Home.Post._name,
    url: 'Post/:postId/:objectType',
};

export const FiHomePostCommentState: Ng2StateDeclaration = {
    name: FiStateNames.Home.Post.Comment,
    url: '/Comment/:commentId',
};

@Component({
    selector: 'fi-module-state',
    template: '<ui-view></ui-view>',
    encapsulation: ViewEncapsulation.None,
    styles: ['fi-module-state, fi-module-state ui-view{display: block;height: 100%;overflow: auto}'],
    standalone: false,
})
export class FiModuleStateComponent {}

export const FiModuleState: Ng2StateDeclaration = {
    name: FiStateNames.Module,
    url: '/Module',
    abstract: true,
    component: FiModuleStateComponent,
};
